import script from "./OCapacidadeValorLista.vue?vue&type=script&lang=ts&setup=true"
export * from "./OCapacidadeValorLista.vue?vue&type=script&lang=ts&setup=true"

import "./OCapacidadeValorLista.vue?vue&type=style&index=0&id=13c99708&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c99708"]])

export default __exports__